import { CHECKPOINT_ACTION_TYPE } from '@/map-phaser-new/constants'
import type { CheckpointsObjectInterface } from '@/map-phaser-new/interfaces'

export const cableCarToUpCheckpoints: CheckpointsObjectInterface = {
  key: 'cableCarToUpCheckpoints',
  data: [
    {
      x: 3127,
      y: 417,
      width: 10,
      height: 10,
      actionData: {
        type: CHECKPOINT_ACTION_TYPE.AnimationAction,
        action: {
          normal: 'cableCarToUpAnimations1',
        },
      },
    },
  ],
}
